import React, { useState,useRef, useEffect } from "react";


import makeStyles from "@material-ui/core/styles/makeStyles";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import styles from "assets/jss/material-kit-react/components/leaderBoard.js";

import Config from "../../config.js"
import Axios from "axios";
import swal from 'sweetalert'



const useStyles = makeStyles(styles);

function Row(props) {
  const { row } = props;
  const classes = useStyles();
  return (
   <TableRow  className={classes.RightToLeft} key={row.name}>
              <TableCell className={classes.RightToLeft+" "+classes.Row+ ((row.mine)?' '+classes.Mine:'')} component="th" scope="row">
                {row.rank}
              </TableCell>
              <TableCell className={classes.RightToLeft+" "+classes.Row+ ((row.mine)?' '+classes.Mine:'')} align="right">{row.name}</TableCell>
              <TableCell className={classes.RightToLeft+" "+classes.Row+ ((row.mine)?' '+classes.Mine:'')} align="right">{row.score}</TableCell>
    </TableRow>
  );
}






const LeaderBoard = React.forwardRef((props, ref) => {
    const {
        refresh , 
        challengeId,
        ...rest
    } = props;
    const classes = useStyles();
    useEffect(() => {
        GetData(challengeId);
    },[refresh]);
    const [board, setBoard] = React.useState(null);

    const GetData = (cid) => {
        Axios.post(Config.api + "LeaderBoard/GetBoard", {
            challengeId: cid,
            offset:0
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setBoard(result.data.data)
            }).catch((err) => {
                if (err&&err.response&&err.response.status&&err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err&&err.response&&err.response.status&&err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
            })
    }
    
      return (
           <TableContainer >
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
                <TableCell>#</TableCell>
                <TableCell>نام</TableCell>
                <TableCell align="right">امتیاز</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {board && board.map((row) => (
            <Row key={row._id} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
      );
});


export default LeaderBoard;
